import PropTypes from 'prop-types';

import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';

import * as Styled from '../../ProductCard.style';

function CardLink({ clicksreamProps, url, title }) {
  const handleLinkPressed = useLinkPressedCallback({
    destination: url,
    ...clicksreamProps
  });

  return (
    <Styled.FauxLink
      aria-label={title}
      onClick={handleLinkPressed}
      url={url}
    />
  );
}

CardLink.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  clicksreamProps: PropTypes.object,
  url: PropTypes.string,
  title: PropTypes.string.isRequired
};

export default CardLink;
